<template>
 <div class="column is-12">
    <div class="card">
      <header class="header-card">
        <p>
          {{$t('societes.fonctionnement.yield.title')}}
        </p>
      </header>
      <div class="card-content">
        <div class="columns is-multiline">
          <user-tag-input
            v-model="decideurSelected"
            @input="setDecideurs"
            :label="$t('societes.fonctionnement.yield.decideurCommercial')"
            :critere="(u) => [constantes.DIRECTEUR_COMMERCIAL].includes(u.profil)"
            class="column is-6"
          />
          <user-tag-input
            v-model="utilisateurSelected"
            @input="setUtilisateurs"
            :label="$t('societes.fonctionnement.yield.utilisateursNonControles')"
            class="column is-6"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import messageErreur from '@/services/general/messageErreur';
import { DIRECTEUR_COMMERCIAL } from '@/configuration/parametrage/utilisateurConf';
import userTagInput from '@/components/commun/user/userTagInput';

const Parametres = createNamespacedHelpers('parametres');

export default {
  props: {
    societe: {
      type: Object,
      required: true,
    },
  },
  components: {
    userTagInput,
  },
  data() {
    return {
      decideurSelected: [],
      utilisateurSelected: [],
      constantes: {
        DIRECTEUR_COMMERCIAL,
      },
    };
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    users() {
      return this.parametre(PARAMETRES_KEYS.utilisateur);
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametreUtilisateur: 'loadParametreUtilisateur',
    }),
    setDecideurs() {
      this.societe.decideurCommercialIds = this.decideurSelected
        .map(u => u.id);
    },
    setUtilisateurs() {
      this.societe.utilisateursNonControles = this.utilisateurSelected
        .map(u => u.id);
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametreUtilisateur();
      this.utilisateurSelected = this.users
        .filter(u => this.societe.utilisateursNonControles.includes(u.id));
      this.decideurSelected = this.users
        .filter(u => u.profil === DIRECTEUR_COMMERCIAL)
        .filter(u => this.societe.decideurCommercialIds.includes(u.id));
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};
</script>

<style>

</style>
